import * as React from 'react';
import { devNote } from '@xingternal/malt-util';
import { Styled } from './flag.styles';
const flagVariantText = {
    ambassador: 'Ambassador',
    basic: 'Basic',
    beta: 'Beta',
    insider: 'Insider',
    moderator: 'Moderator',
    new: 'New',
    newsplus: 'News Plus',
    premium: 'Premium',
    proBusiness: 'ProBusiness',
    proCoach: 'ProCoach',
    proJobs: 'ProJobs',
    proTrainer: 'ProTrainer',
    local: 'Local', // DEPRECATED
};
export const Flag = ({ className, icon, innerRef, onClick, show = true, size = 'medium', sizeConfined, sizeWide, variant, ...props }) => {
    /** DEPRECATED: 17.09.2021 */
    if (variant === 'newsplus') {
        devNote.deprecate(`The "newsplus" variant is deprecated and should be removed as soon as possible.`);
    }
    if (variant === 'local') {
        devNote.deprecate(`The "local" variant is deprecated and should be removed as soon as possible.`);
    }
    return (React.createElement(React.Fragment, null, show ? (React.createElement(Styled.Flag, { "$size": size, "$sizeConfined": sizeConfined, "$sizeWide": sizeWide, "$variant": variant, className: className, onClick: onClick, ref: innerRef, ...props },
        React.createElement(Styled.Text, { forwardedAs: "span", size: "xsmall", fontWeight: "bold", noMargin: true },
            flagVariantText[variant],
            icon))) : null));
};
Flag.displayName = 'Flag';
//# sourceMappingURL=flag.js.map